<div class="modal-header">
    <h4
        class="modal-title"
        id="modal-title"
    >{{ title }}</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Close button"
        aria-describedby="modal-title"
        (click)="activeModal.dismiss('Cross click')"
    ></button>
</div>
<div class="modal-body">
    <p><strong>{{ message }}</strong></p>
    @if (isReversible) {
        <span class="text-danger">This operation cannot be undone.</span>
    }
</div>
<div class="modal-footer">
    @if(cancelButtonText !== ""){
      <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="cancel()"
      >{{ cancelButtonText }}</button>
    }
    <button
        type="button"
        ngbAutofocus
        class="btn"
        [class.btn-primary]="type === 'default'"
        [class.btn-danger]="type === 'danger'"
        (click)="confirm()"
    >{{ confirmButtonText }}</button>
</div>
